import { TemplateAction } from '../../action-types';
import { VideoTemplateStateContent } from '../../types';
import { setNewLayerPosition } from './mutations';

export default function reducer(
  state: VideoTemplateStateContent,
  action: TemplateAction,
): VideoTemplateStateContent {
  switch (action.type) {
    case 'LAYER_POSITION_CHANGE': {
      const { layerId, moveTo } = action.payload;

      return setNewLayerPosition(state, layerId, moveTo);
    }

    default:
      return state;
  }
}
